import { useState } from "react";
import { FaServer, FaUsers, FaCloud, FaShieldAlt } from "react-icons/fa";
import { PageShell, PageHeader, DetailTabs } from "../../../Components/shared";
import ClientsTab from "../../../Components/emqx/storageRoles/ClientsTab";
import UsersTab from "../../../Components/emqx/storageRoles/UsersTab";
import AclTab from "../../../Components/emqx/storageRoles/AclTab";

const TABS = [
  { id: "clients", label: "Bağlı Cihazlar", icon: FaServer, bg: "bg-blue-500" },
  { id: "users", label: "Kullanıcılar", icon: FaUsers, bg: "bg-indigo-500" },
  { id: "acl", label: "ACL", icon: FaShieldAlt, bg: "bg-emerald-500" },
];

/**
 * EMQX Yonetim — admin paneli (sadece admin role gorur).
 * Tek sayfa icinde sub-tabs: bagli MQTT clientlari + auth user yonetimi.
 */
export default function EmqxPage() {
  const [tab, setTab] = useState("clients");

  return (
    <PageShell>
      <div className="px-3 py-2.5 sm:p-4 md:p-6 bg-gray-50/80 sm:bg-gray-50 shrink-0 border-b border-gray-100">
        <PageHeader
          icon={FaCloud}
          iconColor="indigo"
          title="EMQX Yönetim"
          subtitle="MQTT broker authentication ve bağlı cihaz izleme."
        />
      </div>

      <DetailTabs tabs={TABS} activeTab={tab} onChange={setTab} />

      <div className="flex-1 min-h-0 overflow-hidden">
        {tab === "clients" && <ClientsTab />}
        {tab === "users" && <UsersTab />}
        {tab === "acl" && <AclTab />}
      </div>
    </PageShell>
  );
}
